// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eMz66e {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  overflow: hidden;
  gap: 0;
  margin-left: -24px;
  margin-right: -24px;
  width: calc(100% + 48px);
}

.d0kpNc {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  height: 100vh;
}

.sm88n4 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0;
  padding: 0;
}

.LBwbul {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: var(--spacing-6);
  background-color: var(--color-neutral-50);
  overflow-y: auto;
}

.sBxl4B {
  padding: 32px 90px 78px 90px;
  height: 110vh;
  overflow-y: auto;
}

.xqScTO {
  padding: 32px 90px 78px 90px;
  height: 100vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .eMz66e {
    grid-template-columns: 1fr;
    grid-template-rows: 300px 1fr;
    margin-left: -24px;
    margin-right: -24px;
    width: calc(100% + 48px);
  }

  .d0kpNc {
    grid-row: 1;
  }

  .LBwbul {
    grid-row: 2;
    padding: var(--spacing-4);
  }
}

@media (max-width: 480px) {
  .LBwbul {
    padding: var(--spacing-3);
  }
}

.vcgDYi {
}

.lvrqyp {
}

/* Text overlay on hero image - matches Figma design */
.YiCyn0 {
  position: absolute;
  top: 126px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 2;
  width: 400px;
  height: 90px;
  padding: 0 24px;
}

.cwf2bF {
  font-family: Clario, sans-serif;
  font-weight: 400;
  font-size: 32px;
  line-height: 1em;
  color: #ffffff;
  margin: 0 0 12px 0;
  text-align: center;
}

.clBna8 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6em;
  color: #ffffff;
  margin: 0;
  text-align: center;
  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/HeroContentLayout/HeroContentLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;AAEA;;AAEA;AAEA;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[".heroLayout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  height: 100vh;\n  overflow: hidden;\n  gap: 0;\n  margin-left: -24px;\n  margin-right: -24px;\n  width: calc(100% + 48px);\n}\n\n.heroImageSection {\n  position: relative;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n}\n\n.heroImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n\n.heroContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: var(--spacing-6);\n  background-color: var(--color-neutral-50);\n  overflow-y: auto;\n}\n\n.heroContentClient {\n  padding: 32px 90px 78px 90px;\n  height: 110vh;\n  overflow-y: auto;\n}\n\n.heroContentAccounting {\n  padding: 32px 90px 78px 90px;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .heroLayout {\n    grid-template-columns: 1fr;\n    grid-template-rows: 300px 1fr;\n    margin-left: -24px;\n    margin-right: -24px;\n    width: calc(100% + 48px);\n  }\n\n  .heroImageSection {\n    grid-row: 1;\n  }\n\n  .heroContent {\n    grid-row: 2;\n    padding: var(--spacing-4);\n  }\n}\n\n@media (max-width: 480px) {\n  .heroContent {\n    padding: var(--spacing-3);\n  }\n}\n\n.heroContentContainer {\n  composes: heroLayout;\n}\n\n.contentSection {\n  composes: heroContent;\n}\n\n/* Text overlay on hero image - matches Figma design */\n.heroTextOverlay {\n  position: absolute;\n  top: 126px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  z-index: 2;\n  width: 400px;\n  height: 90px;\n  padding: 0 24px;\n}\n\n.heroTitle {\n  font-family: Clario, sans-serif;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 1em;\n  color: #ffffff;\n  margin: 0 0 12px 0;\n  text-align: center;\n}\n\n.heroSubtitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.6em;\n  color: #ffffff;\n  margin: 0;\n  text-align: center;\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroLayout": `eMz66e`,
	"heroImageSection": `d0kpNc`,
	"heroImage": `sm88n4`,
	"heroContent": `LBwbul`,
	"heroContentClient": `sBxl4B`,
	"heroContentAccounting": `xqScTO`,
	"heroContentContainer": `vcgDYi eMz66e`,
	"contentSection": `lvrqyp LBwbul`,
	"heroTextOverlay": `YiCyn0`,
	"heroTitle": `cwf2bF`,
	"heroSubtitle": `clBna8`
};
module.exports = ___CSS_LOADER_EXPORT___;
